import React, { useEffect, useState } from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import { InvestmentDTO } from '../../model/investmentDTO';
import { ValuesDTO } from '../../model/valuesDTO';
import './TableView.scss';
import { MarketNames } from '../../shared/constants';
import { currencyFormatter } from '../../utils/commonFunctions';
interface TableData {
  strategyData: InvestmentDTO;
}

const priceFormatter = (cell: number) => {
  return (
    <span className="text-center">{
      currencyFormatter(cell)
    }</span>
  );
}
const percentageFormat2decimals = new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 });
const percentageFormatter = (cell: number) => {
  const percentage = cell === 0 ? 0 : percentageFormat2decimals.format(cell);
  return (
    <span className="text-center"> {percentage}&#37;</span>
  );
}
const TableView = (props: TableData) => {

  const columns = [{
    dataField: 'description',
    text: 'Description'
  }, {
    dataField: 'amount',
    text: 'Allocation Amount',
    align: 'center',
    headerAlign: 'center',
    formatter: priceFormatter
  }, {
    dataField: 'indexReturn',
    text: 'Index return',
    align: 'center',
    headerAlign: 'center',
    formatter: percentageFormatter
  }, {
    dataField: 'strategyReturn',
    text: 'Strategy return',
    align: 'center',
    headerAlign: 'center',
    formatter: percentageFormatter
  }, {
    dataField: 'endingValue',
    text: 'Strategy ending value',
    align: 'center',
    headerAlign: 'center',
    formatter: priceFormatter
  }];
  const rowClasses = 'custom-row-class';
  const isDualDirection = props.strategyData.calculatorInputsDTO.strategyType === 'dualDirection'; 
  const formatIllustrationModel = (model: string) => {    
    if (model.toUpperCase() === 'UPMARKET') {
      return MarketNames.UPMARKET;
    } else if (model.toUpperCase() === 'DOWNMARKET') {
      return MarketNames.DOWNMARKET;
    } else if (model.toUpperCase() === 'TERM') {
      return MarketNames.TERM;
    } else {
      return '';
    }
  }
  const formatIllustrationDualDirectionModel = (model: string) => {    
    if (model.toUpperCase() === 'UPMARKET') {
      return MarketNames.UPMARKET;
    } else if (model.toUpperCase() === 'DOWNMARKETLESSTHANEQUALBUFFER') {
      return MarketNames.DOWNMARKET_LESS_THAN_BUFFERED;
    } else if (model.toUpperCase() === 'DOWNMARKETGREATERTHANBUFFER') {
      return MarketNames.DOWNMARKET_GREATER_THAN_BUFFERED;
    } else if (model.toUpperCase() === 'TERM') {
      return MarketNames.TERM;
    } else {
      return '';
    }
  }
  const rowData = (marketValue: ValuesDTO) => {
    return {
      description: (<span> {(isDualDirection) ? formatIllustrationDualDirectionModel(marketValue?.illustrationModel):formatIllustrationModel(marketValue?.illustrationModel)}
        <br /> January  {marketValue.illustrationModelStartYear} to December {marketValue.illustrationModelEndYear}</span>),
      amount: marketValue.allocationAmount,
      indexReturn: marketValue.indexReturnPercentage,
      strategyReturn: marketValue.strategyReturnPercentage,
      endingValue: marketValue.strategyEndingValue,
      key: marketValue.illustrationModel

    };
  };
  const preparetableData = () => {
    const dataObj = props.strategyData;
    if (dataObj) {
      return (isDualDirection) ? [rowData(dataObj.valuesDownMarketLessThanEqualBuffer),rowData(dataObj.valuesDownMarketGreaterThanBuffer), rowData(dataObj.valuesUpMarket), rowData(dataObj.valuesCustomMarket)]:[rowData(dataObj.valuesDownMarket), rowData(dataObj.valuesUpMarket), rowData(dataObj.valuesCustomMarket)];
    }
    return [];
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [tableData, setTableData] = useState<any>([]);
  useEffect(() => {
    const data = preparetableData();
    setTableData(data);
  }, [props.strategyData]);

  return (
    <div className="bg-lightest-blue p-4 pr-5 pl-5 table-style">
      <BootstrapTable keyField='key' data={tableData} columns={columns}
        striped
        hover
        bordered={false}
        rowClasses={rowClasses}
        headerClasses="header-class" />

    </div>
  );
}

export default TableView;